export const LOGO_URL = '/basel/media/logo-768.png';
export const LOGO_WHITE_URL = '/basel/media/logo-white.png';

export const TOPBAR_PHONE = '+1 (305) 599 - 8282';
export const TOPBAR_PHONE_HREF = 'tel:+13055998282';

export const BASEL_HTML_CLASS = 'document-ready';

export const BASEL_PAGE_CLASSES = [
  'home',
  'page',
  'archive',
  'post-type-archive',
  'post-type-archive-product',
  'single-product',
  'woocommerce-page'
];

export const BASEL_BODY_CLASSES = [
  'wrapper-full-width',
  'global-cart-design-2',
  'global-search-full-screen',
  'global-header-simple',
  'mobile-nav-from-left',
  'basel-light',
  'catalog-mode-off',
  'categories-accordion-on',
  'basel-top-bar-on',
  'enable-sticky-header',
  'header-full-width',
  'sticky-header-clone',
  'offcanvas-sidebar-mobile',
  'offcanvas-sidebar-tablet',
  'woocommerce',
  'woocommerce-js',
  'wpb-js-composer',
  'vc_responsive'
];

export interface NavLink {
  label: string;
  path: string;
  query?: Record<string, string>;
  children?: NavLink[];
}

/** Static storefront links (category menus come from the categories API). */
export const STATIC_NAV: NavLink[] = [
  { label: 'Home', path: '/' },
  { label: 'Contact Us', path: '/contact' },
  { label: 'About Us', path: '/story' },
  { label: 'FAQs', path: '/faqs' }
];
